/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import GenericModal from 'app/views/components/Modals/GenericModal'
import settings from 'settings'
import { connect } from 'react-redux'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import UIkit from 'uikit'

import Star from 'app/views/components/Modals/ModalCompletedLesson/components/Star'
import Icon from 'app/views/components/Icon'
import { api } from 'app/views/utils/api'
import analytics from 'app/views/utils/analytics'

import {
  showCodeReviewModal,
  getHint,
} from 'app/state/modules/codeReview'
import Term from '../../Terminal'
import Statistics from '../../Statistics'
// import HintModal from './HintDetailModal'
import FormatedMinutes from '../../FormatedMinutes'

import ModalListItem from './ModalListItem'

import HintModal from './HintModal'
import { Button } from '@hackedu/react-components'

class ModalCodeReview extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      rating: 0,
      feedback: '',
      showErrorLoading: false,
    }
    this.renderContentModal = this.renderContentModal.bind(this)
    this.onSubmitFeedback = this.onSubmitFeedback.bind(this)
    this.handleChangeFeedback = this.handleChangeFeedback.bind(this)
    this.renderNextButtons = this.renderNextButtons.bind(this)
    this.renderHintButtons = this.renderHintButtons.bind(this)
    this.renderErrorTitle = this.renderErrorTitle.bind(this)
    this.renderDefaultMarkdown = this.renderDefaultMarkdown.bind(this)
    this.hide = this.hide.bind(this)
    this.show = this.show.bind(this)
    this.modal = React.createRef()
    this.term = React.createRef()
    this.hintModal = React.createRef()
  }

  componentDidUpdate(prevProps) {
    if ((prevProps.modal !== this.props.modal) && this.props.modal !== null) {
      this.modal.current.show()
    } else if ((typeof prevProps.modal === 'string') && this.props.modal === null) {
      this.modal.current.hide()
    }
  }

  componentWillUnmount() {
    if (this.timeoutFail) {
      clearTimeout(this.timeoutFail)
    }
  }

  onSubmitFeedback(callback) {
    if (this.state.rating > 0) {
      api({
        method: 'post',
        url: `${settings.urls.hacker}/feedback`,
        data: {
          content_uuid: this.props.contentUUID,
          message: this.state.feedback,
          stars: this.state.rating,
        },
        idToken: this.props.idToken,
      })
        .then((response) => {
          if (response.data.success === true) {
            analytics.track('feedback')
          }
          if (!this.props.isAssessment) {
            this.props.push('/')
          }
        })
        .catch((error) => {
          console.error(error)
        })
    } else if (!this.props.isAssessment) {
      this.props.push('/')
    }
  }

  handleChangeFeedback(e) {
    this.setState({
      feedback: e.target.value,
    })
  }

  show() {
    this.modal.current.show()
  }

  hide() {
    this.modal.current.hide()
  }

  destroy() {
    this.modal.current.destroy()
  }

  renderHintButtons() {
    return (
      <div className="uk-child-width-1-3 uk-flex-center uk-grid uk-grid-match" uk-grid="">
        {this.props.hints.map((hint) => {
          const used = typeof (this.props.usedHints || this.props.metadata.usedHints || {})[hint.id] === 'number'
          let cardType = ''
          const disabled = false
          if (hint.hint_type === 'basic') {
            cardType = 'uk-card-default'
          } else if (hint.hint_type === 'highlight') {
            cardType = 'uk-card-primary'
          } else {
            return null
          }
          return (
            <div
              key={hint.id}
              onClick={() => {
                if (!disabled) {
                  if (hint.hint_type === 'highlight') {
                    UIkit.modal.confirm(`Using this hint requires us to reset any changes you have made to the app and give you a new sandbox.
                    Are you sure you want to proceed?`, {
                      stack: true,
                    })
                      .then(() => {
                        this.props.showCodeReviewModal(null)
                        this.props.onResetSandbox(() => {
                          this.props.getHint(
                            hint.id,
                            (hintModalData) => {
                              if (this.props.updateParentContentHints) {
                                this.props.updateParentContentHints({
                                  [hint.id]: hintModalData.metadata.points,
                                })
                              }
                              this.setState({
                                hintModalData,
                              })
                            },
                            this.props.isAssessment ? this.props.assessmentUUID : null,
                          )
                        }, true)
                      }, () => {

                      })
                  } else {
                    this.props.getHint(
                      hint.id,
                      (hintModalData) => {
                        if (this.props.updateParentContentHints) {
                          this.props.updateParentContentHints({
                            [hint.id]: hintModalData.metadata.points,
                          })
                        }
                      },
                      this.props.isAssessment ? this.props.assessmentUUID : null,
                    )
                  }
                }
              }}
            >
              <div
                uk-tooltip={used ? 'You\'ve already used this hint' : null}
                className={`uk-flex  uk-flex-column  uk-flex-center uk-flex-middle uk-card ${cardType} uk-text-center uk-padding-small${used || disabled ? '' : ' uk-card-hover'}`}
                style={{
                  cursor: 'pointer',
                  ...((used || disabled) && this.props.contentType != 'mobile' ? {
                    backgroundColor: '#f8f8f8',
                  } : {}),
                }}
              >
                <h5
                  className={`uk-margin-remove${(used || disabled) && this.props.contentType != 'mobile' ? ' uk-text-muted' : ''}`}
                >
                  {hint.title}
                </h5>
                <hr
                  className="uk-align-center uk-margin-small"
                  style={{ width: '50%' }}
                />
                <h5
                  className={`uk-margin-remove${(used || disabled) && this.props.contentType != 'mobile' ? ' uk-text-muted' : ''}`}
                >
                  {`${used || disabled ? (disabled ? 'Unavailable' : 'View') : (this.props.contentType != 'mobile' ? `${hint.points} Points` : '')}`}
                </h5>
              </div>


            </div>
          )
        })}

      </div>
    )
  }


  renderNextButtons() {
    if (this.props.isAssessment && this.props.isTimeOut) {
      return (
        <Button
          onClick={() => {
            this.props.showCodeReviewModal('next_question')
            this.props.showCodeReviewModal('hide')
          }}
          default
          content="Next Question"
        />
      )
    }
    return (
      <>
        <Button
          primary
          onClick={() => this.hide()}
          content="Try Again"
        />
        <Button
          onClick={() => {
            if (this.props.isAssessment) {
              this.props.onSkipQuestion()
            } else {
              this.modal.current.destroy()
              window.location.assign('/')
            }
          }}
          default
          content="Skip Question"
        />
      </>
    )
  }

  renderErrorTitle() {
    switch (this.props.errorName) {
      case 'syntax_error':
        return 'Syntax Error'
      case 'functionality_broken':
        return 'Functionality Broken'
      case 'vulnerability_not_fixed':
        return 'Vulnerability Not Fixed'
      default:
        return 'Test Failed'
    }
  }

  renderDefaultMarkdown() {
    if (this.props.errorMarkdown) {
      return (
        <ReactMarkdown
          rehypePlugins={[rehypeRaw]}
          linkTarget="_blank"
          children={this.props.errorMarkdown}
        />
      )
    }
    switch (this.props.errorName) {
      case 'syntax_error':
        return 'There was a syntax error when trying to run your code.  Syntax errors do not count against your score'
      case 'functionality_broken':
        return 'It looks like your code submission broke the intended functionality of the app. Make sure your fix doesn\'t break the app and try again.'
      case 'vulnerability_not_fixed':
        return 'It looks like your code is still vulnerable.'
      default:
        return ''
    }
  }





  renderContentModal() {
    return (
      <>
        {(() => {
          switch (this.props.modal) {
            case 'loading':
              if (this.state.showErrorLoading) {
                return (
                  <>
                    <div className="uk-padding-large uk-flex uk-flex-middle uk-flex-center uk-flex-column">
                      <Icon
                        name="error-warning"
                        className="uk-text-danger"
                        ratio={3}
                      />
                      <p>
                        Something went wrong with our tests, and our team has been notified.
                        This doesn't mean your submission is incorrect.
                      </p>
                      <p>
                        You can either refresh this page and try again,
                        or start a new lesson/challenge.
                      </p>
                    </div>
                  </>
                )
              }
              return (
                <>
                  <div className="uk-padding-large uk-flex uk-flex-middle uk-flex-center uk-flex-column">
                    <h2 className="uk-text-center">Please wait while your code is assessed...</h2>
                    <div data-uk-spinner="ratio:1.5" className="uk-margin-top" />
                    <br />
                    <br />
                    <Statistics
                      header={`${this.props.patchingTime || 10}`}
                      content={(
                        <span>
                          SECONDS
                        </span>
                      )}
                      detail="ESTIMATED TEST TIME"
                    />
                  </div>
                </>
              )
            case 'syntax_error':
              return (
                <div className="uk-flex uk-flex-column uk-flex-center uk-flex-middle uk-flex-1 uk-padding uk-text-center uk-text-secondary">
                  <h2
                    className="uk-flex uk-flex-middle uk-flex-center"
                  >
                    <Icon name="error-warning" ratio={1.5} className="uk-margin-small-right uk-text-warning" />
                    Syntax Error
                  </h2>
                  <h4 className="uk-text-italic">
                    Whoops!  It looks like your  code has a syntax error!
                    Don't worry, Syntax errors do not count  against your score.
                  </h4>
                  <h4 className="uk-text-italic">
                    You can see the code output below:
                  </h4>
                  <div
                    style={{
                      height: 200,
                      width: '100%',
                      position: 'relative',
                    }}
                  >
                    <Term
                      disableInit
                      className="uk-width-1-1"
                      style={{
                        height: 200,
                        width: '100%',
                      }}
                      ref={this.term}
                      id="modal-feedback-terminal"
                    />
                  </div>
                  <div
                    className="uk-width-1-1 uk-flex uk-flex-row uk-flex-middle uk-flex-around uk-margin-large-top"
                  >
                    {this.renderNextButtons()}
                  </div>
                </div>
              )
            case 'test_failed':
              return (
                <div className="uk-flex uk-flex-column uk-flex-center uk-flex-middle uk-flex-1 uk-padding">
                  <h2
                    className="uk-flex uk-flex-middle uk-flex-center"
                  >
                    <Icon name="error-warning" ratio={1.5} className="uk-margin-small-right uk-text-danger" />
                    {this.renderErrorTitle()}
                  </h2>
                  <br />
                  <br />
                  {this.renderDefaultMarkdown()}
                  {this.props.relatedContent && this.props.relatedContent.length > 0 && (
                    <>
                      <hr />
                      <h2>
                        Additional Resources
                      </h2>
                      <ul className="uk-list">
                        {this.props.relatedContent.map((content) => (
                          <li key={content.related_content_uuid}>
                            <h4>
                              <a
                                href={`${settings.urls.app}/content/${content.related_content_uuid}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {content.title}
                              </a>
                            </h4>
                          </li>
                        ))}
                      </ul>
                    </>
                  )}
                  <div
                    className="uk-width-1-1 uk-flex uk-flex-row uk-flex-middle uk-flex-around uk-margin-large-top"
                  >
                    {this.renderNextButtons()}
                  </div>
                </div>
              )
            case 'test_success':
            case 'next_question':
            case 'question_times_up':
              return (
                <div className="uk-flex uk-flex-column uk-flex-center uk-flex-middle uk-flex-1 uk-padding uk-text-center uk-text-secondary">
                  {this.props.modal === 'test_success' && (
                    <h2
                      className="uk-flex uk-flex-middle uk-flex-center"
                      style={{
                        marginBottom: 45,
                      }}
                    >
                      {this.props.contentType === "mobile" ? (
                        <>Congrats! You have successfully completed this lesson.</>
                      ) : (
                        <>Congrats! You have successfully completed this coding challenge.</>
                      )}
                    </h2>
                  )}

                  {this.props.modal === 'next_question' && (
                    <>
                      <h1 className="uk-text-center">
                        Question Saved
                      </h1>
                      <h4>
                        Click "Next Question" to continue.
                      </h4>
                    </>
                  )}
                  {this.props.modal === 'question_times_up' && (
                    <>
                      <h1 className="uk-text-center">
                        Question Time Up.
                      </h1>
                      <h4 className="uk-margin-remove">
                        Your time limit for this question has expired. Please continue to the next question.
                      </h4>
                    </>
                  )}
                  {(this.props.modal === 'test_success' && this.props.contentType !== 'mobile') && (
                    <div
                      className="uk-flex uk-flex-row uk-flex-middle uk-flex-around uk-width-1-1"
                    >
                      <Statistics
                        header={this.props.successDetailModal.hints}
                        content=""
                        detail="Hints Used"
                      />
                      <Statistics
                        header={(
                          <FormatedMinutes
                            minutes={this.props.successDetailModal.total_time}
                          />
                        )}
                        content=""
                        detail="Total Time"
                      />
                      <Statistics
                        header={this.props.successDetailModal.attempts}
                        content=""
                        detail="Patch Attempts"
                      />
                    </div>
                  )
                  }
                  <div className="uk-text-bold uk-margin-top">
                    Rate this lesson
                  </div>
                  <div className="uk-margin-top">
                    <Star
                      selected={(this.state.rating > 0)}
                      handleClick={() => { this.setState({ rating: 1 }) }}
                    />
                    <Star
                      selected={(this.state.rating > 1)}
                      handleClick={() => { this.setState({ rating: 2 }) }}
                    />
                    <Star
                      selected={(this.state.rating > 2)}
                      handleClick={() => { this.setState({ rating: 3 }) }}
                    />
                    <Star
                      selected={(this.state.rating > 3)}
                      handleClick={() => { this.setState({ rating: 4 }) }}
                    />
                    <Star
                      selected={(this.state.rating > 4)}
                      handleClick={() => { this.setState({ rating: 5 }) }}
                    />
                    <Star
                      selected={(this.state.rating > 5)}
                      handleClick={() => { this.setState({ rating: 6 }) }}
                    />
                    <Star
                      selected={(this.state.rating > 6)}
                      handleClick={() => { this.setState({ rating: 7 }) }}
                    />
                    <Star
                      selected={(this.state.rating > 7)}
                      handleClick={() => { this.setState({ rating: 8 }) }}
                    />
                    <Star
                      selected={(this.state.rating > 8)}
                      handleClick={() => { this.setState({ rating: 9 }) }}
                    />
                    <Star
                      selected={(this.state.rating > 9)}
                      handleClick={() => { this.setState({ rating: 10 }) }}
                    />
                  </div>

                  <div className="uk-margin-top uk-width-1-1">
                    <p>
                      Please share any feedback you have:
                    </p>
                    <textarea
                      className="uk-textarea uk-width-1-1"
                      rows="8"
                      value={this.state.feedback}
                      onChange={this.handleChangeFeedback}
                    />
                  </div>
                  <br />
                  <Button
                    onClick={this.props.onNextQuestion ? () => {
                      this.onSubmitFeedback()
                      this.props.onNextQuestion()
                    } : this.onSubmitFeedback}
                    primary
                    style={{
                      alignSelf: 'flex-end'
                    }}
                    content="Next Question"
                  />
                </div>
              )
            case 'hint':
              return (
                <>
                  <HintModal
                    {...(this.props || {})}
                    ref={this.hintModal}
                  />
                </>
              )
            default:
              return null
          }
        })()}

      </>
    )
  }

  render() {
    return (
      <div id="code-review-container-modal">
        <GenericModal
          options={{
            container: '#code-review-container-modal',
          }}
          activeListeners
          beforeShow={() => {
            this.setState({
              rating: 0,
              feedback: '',
            }, () => {
              this.timeoutFail = setTimeout(() => {
                if (this.props.modal === 'loading') {
                  this.setState({
                    showErrorLoading: true,
                  })
                }
              }, 300 * 1000)
            })
          }}
          afterShown={() => {
            if (this.props.modal === 'syntax_error') {
              if (this.timeoutFail) {
                clearTimeout(this.timeoutFail)
              }
              this.term.current.init(() => {
                const terminal = this.term.current.getTerminal()
                terminal.clear()
                terminal.write(this.props.stackTrace)
              })
            }
          }}
          style={{
            ...(this.props.modal !== 'hint' ? {
              minHeight: window.innerHeight * 0.5,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            } : null)
          }}
          // width="uk-width-1-2"
          noOverflow
          noButtons
          notTitle

          noPadding
          handleOnClickOverlay={() => {
            if (this.props.modal === 'hint') {
              this.props.showCodeReviewModal(null)
            }
          }}
          centered
          ref={this.modal}
          id="modal-code-review"
          body={(
            <>
              {this.renderContentModal()}
            </>
          )}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ codeReview, auth }) => ({
  modal: codeReview.modal,
  idToken: auth.user.idToken,
  successDetailModal: codeReview.successDetailModal,
  stackTrace: codeReview.stackTrace,
  errorMarkdown: codeReview.errorMarkdown,
  errorName: codeReview.errorName,
})

export default connect(mapStateToProps, {
  showCodeReviewModal,
  getHint,
})(ModalCodeReview)
